import React, { FC } from 'react'
import styles from 'styles/components/typography.module.scss'

type Props = {
  caution: string
}

const SubCaution: FC<Props> = (props) => {
  const { caution } = props
  return <p className={styles.description_caution_sub}>{caution}</p>
}

export default SubCaution
